import { SexguidenSok } from './components/main/sok/sok'
import { Emneknagger } from './components/main/sok/emneknagger/emneknagger'
import { SexguidenSokeresultat } from './components/main/sok/resultat/sokeresultat'

if (!customElements.get('dh-sexguiden-emneknagger')) {
  customElements.define('dh-sexguiden-emneknagger', Emneknagger)
}

if (!customElements.get('dh-sexguiden-sok')) {
  customElements.define('dh-sexguiden-sok', SexguidenSok)
}

if (!customElements.get('dh-sexguiden-sokeresultat')) {
  customElements.define('dh-sexguiden-sokeresultat', SexguidenSokeresultat)
}

;(async function loadLibsLazy() {
  const { default: CoreScroll } = await import('@nrk/core-scroll')
  if (!customElements.get('core-scroll')) {
    customElements.define('core-scroll', CoreScroll)
  }
})()
